import React from 'react'

const PanelsComponent = props => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default PanelsComponent
